import { createFileRoute, Outlet } from "@tanstack/react-router";

/*
 * Layout-only route — see domains.tsx. `reports.$reportId` is a child, so the
 * list must live in reports.index.tsx or it renders in place of the detail.
 */
export const Route = createFileRoute("/portal/reports")({
  component: ReportsLayout,
});

function ReportsLayout() {
  return <Outlet />;
}
